
<section id="main" class="bg-light">
     <div
          id="paymentContainer"
          class="container"
     >
          <h1 [innerHtml]="'PaymentMethodsHeader' | translator: 'payment'">
               Manage Payment Methods
          </h1>
          <div class="row">
               <div
                    id="paymentMethodsContainer"
                    class="col-lg-8 mb-3 mb-lg-0"
               >
                    <app-methods />
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <app-dashboardsupport />
                    <div class="card shadow-sm rounded-0 border-0 mb-3">
                         <div class="card-body">
                              <h2
                                   class="h5"
                                   [innerHtml]="'Resources' | translator: 'base'"
                              >
                                   Resources
                              </h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button
                                             (click)="openDocument('PSPMotorCarrierEnrollment')"
                                             target="_blank"
                                             class="btn btn-link"
                                             [title]="'MAHEnrollAgreement' | translator: 'base'"
                                             [innerHtml]="'MAHEnrollAgreement' | translator: 'base'"
                                             name="MAHagreement"
                                             id="MAHagreement"
                                        >
                                             PSP Monthly Account Holder Enrollment Agreement
                                        </button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button
                                             (click)="openDocument('ISPAccountHolderAgreement')"
                                             target="_blank"
                                             class="btn btn-link"
                                             [title]="'ISPEnrollAgreement' | translator: 'base'"
                                             [innerHtml]="'ISPEnrollAgreement' | translator: 'base'"
                                             name="ISPagreement"
                                             id="ISPagreement"
                                        >
                                             PSP Industry Service Provider Enrollment Agreement
                                        </button>
                                   </li>
                                   <li>
                                        <button
                                             class="btn btn-link"
                                             [innerHtml]="'DisclosureAndAuth' | translator: 'base'"
                                             [title]="'DisclosureAndAuth' | translator: 'base'"
                                             (click)="openDocument('PSPDisclosureandAuthorizationForm')"
                                             target="_blank"
                                             name="dnaForm"
                                             id="dnaForm"
                                        >
                                             Disclosure and Authorization Form
                                        </button>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>
